<template>
  <v-container class="custom-row-folder hide-scrollbar">
    <v-row class="text-right">
      <GoBackButton />
      <v-col>
        <h2 class="mt-4">
          {{ operatorFolder ? operatorFolder.path : "Please Reload" }}
        </h2>
      </v-col>
    </v-row>

    <v-divider v-if="(linkedFile || notLinkedFile) && operatorFolder.action != 'move'" class="ma-4"></v-divider>

    <v-row v-if="(linkedFile || notLinkedFile) && operatorFolder.action != 'move'">
      <v-col>
        <v-card-title>Shared Files</v-card-title>
        <v-progress-linear
          v-if="loading3"
          indeterminate
          color="primary"
        ></v-progress-linear>
        <v-row v-else-if="!loading3 && linkedFile.length <= 0">
          <v-spacer></v-spacer>
          <span style="font-size: 0.875rem; color: rgba(0, 0, 0, 0.38)">
            No Data Available
          </span>
          <v-spacer></v-spacer>
        </v-row>
        <v-treeview
          v-else
          :items="linkedFile"
          :load-children="fetchLinkedItems"
          item-key="name"
          open-on-click
        >
          <template v-slot:prepend="{ item, open }">
            <v-container d-flex v-if="!item.file">
              <v-icon small>{{
                open ? "mdi-folder-open" : "mdi-folder"
              }}</v-icon>
            </v-container>

            <v-icon small v-else>{{ icons[item.file] }}</v-icon>
          </template>
        </v-treeview>
      </v-col>
      <v-col>
        <v-card-title>Not Shared Files</v-card-title>
        <v-progress-linear
          v-if="loading4"
          indeterminate
          color="primary"
        ></v-progress-linear>
        <v-row v-else-if="!loading4 && notLinkedFile.length <= 0">
          <v-spacer></v-spacer>
          <span style="font-size: 0.875rem; color: rgba(0, 0, 0, 0.38)">
            No Data Available
          </span>
          <v-spacer></v-spacer>
        </v-row>
        <v-treeview
          v-else
          :items="notLinkedFile"
          :load-children="fetchNotLinkedItems"
          item-key="name"
          open-on-click
        >
          <template v-slot:prepend="{ item, open }">
            <v-container d-flex v-if="!item.file">
              <v-icon small>{{
                open ? "mdi-folder-open" : "mdi-folder"
              }}</v-icon>
            </v-container>

            <v-icon small v-else>{{ icons[item.file] }}</v-icon>
          </template>
        </v-treeview>
      </v-col>
    </v-row>

    <v-divider v-if="operatorFolder.action != 'move'" class="ma-4"></v-divider>

    <v-col class="d-block">
      <div v-if="operatorFolder.action != 'move'">
        <v-card-title class="pa-1 pb-5">Shared Companies:</v-card-title>
        <v-data-table
          dense
          :headers="linkedHeaders"
          :items="linkedUsers"
          :loading="loading1"
          class="mb-10"
          hide-default-header
          hide-default-footer
          loading-text="Loading... Please wait"
        >
          <template v-slot:[`item.action`]="{ item }">
            <delete-with-confirm
              :id="item.username"
              @deleted="removeLink($event)"
            />
          </template>
        </v-data-table>
      </div>
      <v-card>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            clearable
            clear-icon="mdi-close-circle-outline"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="companies.filter((el) => isInList(el))"
          :loading="loading2"
          :search="search"
          class="elevation-1 mt-10"
          loading-text="Loading... Please wait"
        >
          <template v-slot:[`item.action`]="{ item }">
            <v-icon
              v-if="operatorFolder.action != 'move'"
              class="mx-2"
              color="primary"
              name="link"
              title="share with customer"
              @click="setLinkFolder(item.name)"
              dark
              >mdi-share-variant</v-icon
            >
            <v-icon
              v-else
              class="mx-2"
              color="primary"
              name="link"
              title="make deliverable with customer using sftp"
              @click="makeDeliverable(item)"
              dark
              >mdi-file-move</v-icon
            >
          </template>
          <template v-slot:no-data>
            <span color="primary">No Data Available</span>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <Confirm
      :dialog.sync="dialog"
      :message.sync="msg"
      @confirm="sendConfirm()"
    />
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import Confirm from "@/components/Confirm.vue";
import DeleteWithConfirm from "@/components/DeleteWithConfirm.vue";
import GoBackButton from "@/components/GoBackButton.vue";

export default {
  data: () => ({
    search: "",
    icons: {
      html: "mdi-language-html5",
      js: "mdi-nodejs",
      json: "mdi-json",
      md: "mdi-markdown",
      pdf: "mdi-file-pdf",
      png: "mdi-file-image",
      txt: "mdi-file-document-outline",
      xls: "mdi-file-excel",
      jpg: "mdi-file-image",
      mp4: "mdi-file-video",
      mkv: "mdi-file-video",
    },
    headers: [
      { text: "Name", value: "alias" },
      { text: "Description", value: "description" },
      { text: "Actions", align: "center", value: "action", sortable: false },
    ],
    linkedHeaders: [
      { text: "Email", value: "username" },
      { text: "Actions", align: "center", value: "action", sortable: false },
    ],
    loading1: false,
    loading2: false,
    loading3: false,
    loading4: false,
    link: {
      path: "",
      username: "",
    },
    dialog: false,
    folder: {
      path: "",
      folderState: "",
    },
    msg: "",
  }),
  components: {
    Confirm,
    DeleteWithConfirm,
    GoBackButton
  },
  computed: {
    ...mapState({
      operatorFolder: (state) => state.operatorFolder,
      companies: (state) => state.companies,
      linkedUsers: (state) => state.linkedUsers,
      linkedFile: (state) => state.linkedFile,
      notLinkedFile: (state) => state.notLinkedFile,
      folderToUploadSharedFile: (state) => state.folderToUploadSharedFile
    }),
  },
  created: async function () {
    this.loading1 = true;
    this.loading2 = true;
    this.loading3 = true;
    this.loading4 = true;
    if (!this.operatorFolder) {
      this.$router.push("/");
    } else {
      if(this.operatorFolder.action == "share") {
        await this.$store.dispatch("setLinkdeUser", this.operatorFolder.name);
        await this.$store.dispatch("getGroupTable");
        await this.$store.dispatch("getNotLinkedFileAction", this.operatorFolder);
        await this.$store.dispatch("getLinkedFileAction", this.operatorFolder);
      } else {
        if(this.operatorFolder.action == "move") {
          await this.$store.dispatch("getGroupTable");
        } else {
          await this.$store.dispatch("setLinkdeUser", this.operatorFolder.name);
          await this.$store.dispatch("getGroupTable");
          await this.$store.dispatch("getNotLinkedFileAction", this.operatorFolder);
          await this.$store.dispatch("getLinkedFileAction", this.operatorFolder);
        }
      }
    }
    this.loading1 = false;
    this.loading2 = false;
    this.loading3 = false;
    this.loading4 = false;
  },
  methods: {
    isInList(val) {
      if(this.operatorFolder.action != "move") {
        let isInList = false;
        this.linkedUsers.forEach((el) => {
          isInList = el.username === val.alias ? true : false;
        });
        return isInList ? null : val;
      }
      return val;
    },
    setLinkFolder(username) {
      this.link.path = this.operatorFolder.name;
      this.msg = "This action will link the folder to the user";
      this.link.username = username;
      this.dialog = true;
    },
    async removeLink(user) {
      this.loading1 = true;
      this.loading2 = true;
      this.loading3 = true;
      this.loading4 = true;
      this.link.path = this.operatorFolder.name;
      this.link.username = user;
      await this.$store.dispatch("getGroupTable");
      this.loading2 = false;
      await this.$store.dispatch("removeLinkFolderCustomer", this.link);
      this.loading1 = false;
      await this.$store.dispatch("getNotLinkedFileAction", this.operatorFolder);
      this.loading4 = false;
      await this.$store.dispatch("getLinkedFileAction", this.operatorFolder);
      this.loading3 = false;
    },
    async sendConfirm() {
      this.loading1 = true;
      this.loading2 = true;
      this.loading3 = true;
      this.loading4 = true;
      if (this.link.path !== "") {
        if(this.operatorFolder.action == "share") {
          await this.$store.dispatch("getGroupTable");
          await this.$store.dispatch("linkFolderCustomer", this.link);
          await this.$store.dispatch(
            "getNotLinkedFileAction",
            this.operatorFolder
          );
          await this.$store.dispatch("getLinkedFileAction", this.operatorFolder);
        } else {
          console.log("this.link", this.link);
          console.log("this.operatorFolder", this.operatorFolder);
        }
      }
      this.loading1 = false;
      this.loading2 = false;
      this.loading3 = false;
      this.loading4 = false;
    },
    async fetchLinkedItems(item) {
      let itemToFetch = {
        name: item.el_properties.name,
        parent: item.masterPath,
      };
      await this.$store.dispatch("getLinkedFileAction", itemToFetch);
    },
    async fetchNotLinkedItems(item) {
      let itemToFetch = {
        name: item.el_properties.name,
        parent: item.masterPath,
      };
      await this.$store.dispatch("getNotLinkedFileAction", itemToFetch);
    },
    makeDeliverable(item) {
      this.loading = true;
      this.$store.dispatch("makeFolderDeliverableCustomer", { elementToDeliver: this.operatorFolder.name,  deliverFolder: this.operatorFolder.path, groupName: item.name});
      this.loading = false;
    },
  },
};
</script>
<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
  display: block;
}
.custom-row-folder {
  overflow-y: scroll;
  height: calc(100% - 4em);
}
.v-treeview-node__root {
  height: 20px;
}
</style>
